function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class HashMap {
    static defaultToString(id) {
        return id.toString(36);
    }
    has(value) {
        return value in this.map;
    }
    get(value) {
        const mapStr = this.map[value];
        if (mapStr) {
            return mapStr;
        }
        if (this.writable) {
            const mapStr = this.toString(this.count);
            this.map[value] = mapStr;
            this.count++;
            return mapStr;
        }
        return value;
    }
    constructor({ source, toString = HashMap.defaultToString, writable = true } = {}){
        _define_property(this, "count", 0);
        _define_property(this, "map", void 0);
        _define_property(this, "toString", void 0);
        _define_property(this, "writable", void 0);
        this.map = source !== null && source !== void 0 ? source : {};
        this.toString = toString;
        this.writable = writable;
    }
}

//# sourceMappingURL=HashMap.js.map